<template>
  <div class="tag-match-type-toggle">
    <label v-if="label" class="toggle-label">{{ label }}</label>
    <div class="toggle-group" :class="{ 'four-options': showNotOptions, 'with-at-least': showAtLeastOption }">
      <button
        type="button"
        class="toggle-btn"
        :class="{ active: modelValue === anyValue }"
        :disabled="disabled"
        @click="$emit('update:modelValue', anyValue)"
      >
        <span class="toggle-badge or">OR</span>
        <span class="toggle-text">任一標籤符合即可</span>
      </button>
      <button
        type="button"
        class="toggle-btn"
        :class="{ active: modelValue === allValue }"
        :disabled="disabled"
        @click="$emit('update:modelValue', allValue)"
      >
        <span class="toggle-badge and">AND</span>
        <span class="toggle-text">必須同時符合所有標籤</span>
      </button>
      <button
        v-if="showAtLeastOption"
        type="button"
        class="toggle-btn"
        :class="{ active: modelValue === atLeastValue }"
        :disabled="disabled"
        @click="$emit('update:modelValue', atLeastValue)"
      >
        <span class="toggle-badge at-least">N/M</span>
        <span class="toggle-text">m 個中符合 n 個</span>
      </button>
      <template v-if="showNotOptions">
        <button
          type="button"
          class="toggle-btn"
          :class="{ active: modelValue === 'NOT_OR' }"
          :disabled="disabled"
          @click="$emit('update:modelValue', 'NOT_OR')"
        >
          <span class="toggle-badge not-or">NOT OR</span>
          <span class="toggle-text">排除含任一標籤的會員</span>
        </button>
        <button
          type="button"
          class="toggle-btn"
          :class="{ active: modelValue === 'NOT_AND' }"
          :disabled="disabled"
          @click="$emit('update:modelValue', 'NOT_AND')"
        >
          <span class="toggle-badge not-and">NOT AND</span>
          <span class="toggle-text">排除同時符合所有標籤的會員</span>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagMatchTypeToggle',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    anyValue: {
      type: String,
      default: 'OR'
    },
    allValue: {
      type: String,
      default: 'AND'
    },
    label: {
      type: String,
      default: '標籤邏輯'
    },
    showNotOptions: {
      type: Boolean,
      default: false
    },
    showAtLeastOption: {
      type: Boolean,
      default: false
    },
    atLeastValue: {
      type: String,
      default: 'AT_LEAST'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
};
</script>

<style scoped>
.tag-match-type-toggle {
  width: 100%;
}

.toggle-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.toggle-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.toggle-group.four-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.toggle-group.with-at-least {
  flex-direction: column;
}

.toggle-group.with-at-least .toggle-btn {
  flex: none;
  width: 100%;
}

.toggle-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #555;
  flex: 1;
  min-width: 160px;
}

.toggle-group.four-options .toggle-btn {
  min-width: 0;
}

.toggle-btn:hover:not(:disabled) {
  border-color: #adb5bd;
  background: #f8f9fa;
}

.toggle-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.toggle-btn.active {
  border-color: #0d6efd;
  background: #f0f5ff;
  color: #0d6efd;
  font-weight: 500;
}

.toggle-btn.active:has(.toggle-badge.not-or),
.toggle-btn.active:has(.toggle-badge.not-and) {
  border-color: #d46b08;
  background: #fff7e6;
  color: #d46b08;
}

.toggle-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 24px;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.toggle-badge.or {
  background: #e6f4ff;
  color: #1677ff;
}

.toggle-badge.and {
  background: #fff0f6;
  color: #c41d7f;
}

.toggle-badge.at-least {
  background: #f6ffed;
  color: #389e0d;
}

.toggle-badge.not-or {
  background: #fff7e6;
  color: #d46b08;
}

.toggle-badge.not-and {
  background: #fff1f0;
  color: #cf1322;
}

.toggle-btn.active .toggle-badge.or {
  background: #1677ff;
  color: #fff;
}

.toggle-btn.active .toggle-badge.and {
  background: #c41d7f;
  color: #fff;
}

.toggle-btn.active .toggle-badge.at-least {
  background: #389e0d;
  color: #fff;
}

.toggle-btn.active .toggle-badge.not-or {
  background: #d46b08;
  color: #fff;
}

.toggle-btn.active .toggle-badge.not-and {
  background: #cf1322;
  color: #fff;
}

.toggle-text {
  font-size: 13px;
}
</style>
